import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toNumber, getItemFromArray, getPointForRef } from "../../components/Common";
import * as APP from "../../redux_store/appState";
import { ClearScratch } from "../layout/PaperDesigner";
import { updateLayout2D } from "../../redux_store/appStateHelper";
import { updateAreaSpecification } from "../../redux_store/jobState";
import { common } from "@material-ui/core/colors";

export const GetItems = (parameters) => {
    if (window.svg && window.paper) {
        return window.paper.project.getItems(parameters);
    }
    return null;
};

const SetChildrenGrey = (item) => {
    if (!item?.children) return;
    item.children.forEach(function (item) {
        if (window.last_pop_item === item) {
            return;
        }
        let alpha = item.fillColor?.alpha;
        if (item.fillColor) {
            item.fillColor = "#dddddd";
            if (alpha) item.fillColor.alpha = alpha;
        }
        if (item.strokeColor) item.strokeColor = "#bbbbbb";
        if (item.is_beam) {
            item.fillColor = "#bbb";
        }
        item.pickable = false;
        if (item.children) {
            SetChildrenGrey(item);
        }
    });
};

function projectPointToLine(mousePoint, p1, p2, online) {
    const v = p2.subtract(p1); // Direction vector of the line
    const w = mousePoint.subtract(p1);
    let t = w.dot(v) / v.dot(v); // Projection scalar
    if (online) {
        t = Math.max(0, Math.min(1, t)); // Clamp t to [0, 1]
    }
    return p1.add(v.multiply(t));
}

function distancePointToLine(point, lineStart, lineEnd) {
    const v = lineEnd.subtract(lineStart); // Direction vector of the line
    const w = point.subtract(lineStart); // Vector from lineStart to point

    // 2D cross product
    const cross = v.x * w.y - v.y * w.x;
    const distance = Math.abs(cross) / v.length;
    return distance;
}
function offsetPointOnNormal(point, lineStart, lineEnd, distance) {
    // Step 1: Direction vector of the line
    const v = lineEnd.subtract(lineStart);
    // Step 2: Normal vector (perpendicular)
    const normal = new window.paper.Point(-v.y, v.x);
    // Step 3: Normalize
    const normalUnit = normal.normalize();
    // Step 4: Scale by distance
    const offset = normalUnit.multiply(distance);
    // Step 5: Offset the point
    return point.add(offset);
}
function offsetPointAlongLine(point, lineStart, lineEnd, distance) {
    // Direction vector from lineStart to lineEnd
    const direction = lineEnd.subtract(lineStart).normalize();
    // Offset the point along the direction by 'distance'
    return point.add(direction.multiply(distance));
}
export function distanceBetween(p1, p2) {
    if (!p1 || !p2) return 0;
    // Preferred: built-in method if available
    if (typeof p1.distance === "function") return p1.distance(p2);
    // Fallback: vector difference length
    return p1.subtract(p2).length;
}

export default function SpecMoveSplice(props) {
    const dispatch = useDispatch();
    const app = useSelector((state) => state.app);
    const { pop_item } = props;

    const SELECT_POINT = app.designer.designer2D[APP.SELECT_POINT];
    const [loaded, setLoaded] = React.useState(false);
    const [firstItem, setFirstItem] = React.useState(false);
    const [lastSVGLoaded, setLastSVGLoaded] = React.useState(window.last_svg_load_attempt);
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);
    const areaIndex = pop_item ? pop_item.areaIndex : 0;

    React.useEffect(() => {
        if (!loaded) return;
        if (SELECT_POINT === false) {
            // Right button - cancel
            let group = window.last_pop_item;
            group.position = group.initial_position;
            onClose();
        }
    }, [SELECT_POINT]);

    if (loaded && window.move_splice_waiting_for_points && window.last_svg_load_attempt != lastSVGLoaded) {
        setLastSVGLoaded(window.last_svg_load_attempt);
        reFormatSVG(0);
    }

    function reFormatSVG(count) {
        if (count > 20) {
            FormatSVGForMovingSplice(props.pop_item);
            return;
        }
        setTimeout(function () {
            if (firstItem == window.paper.project.activeLayer.children[0]) {
                reFormatSVG(count + 1);
            } else {
                FormatSVGForMovingSplice(props.pop_item);
            }
        }, 100);
    }

    function FormatSVGForMovingSplice(pop_item) {
        let items = GetItems();
        setFirstItem(items?.[0]);
        if (items?.[0]?.children) {
            SetChildrenGrey(items?.[0]);
        }

        pop_item.selected = false;
        if (!pop_item) {
            pop_item = window.last_pop_item;
        } else {
            window.last_pop_item = pop_item;
        }
        let text_items = GetItems({ class: window.paper.TextItem });
        text_items.forEach(function (item) {
            if (!item.is_splice) {
                item.sendToBack();
            }
        });

        let groups = [];

        let splice_items = GetItems({ is_splice: true });

        splice_items.forEach(function (dl) {
            if (dl.parent instanceof window.paper.Group && dl.parent.children.length < 50) {
                dl.parent.bringToFront();
                if (
                    !groups.includes(dl.parent) &&
                    pop_item.areaIndex == dl.parent.areaIndex &&
                    pop_item.ref == dl.parent.ref
                ) {
                    groups.push(dl.parent);
                }
            }
        });

        splice_items.forEach(function (dl) {
            dl.bringToFront();
            let alpha = dl.fillColor?.alpha;
            if (alpha > 0.1) {
                dl.strokeColor = "#c1cb03";
            }
            if (!(dl instanceof window.paper.Group)) {
                for (let group of groups) {
                    if (group.areaIndex == dl.areaIndex && group.ref == dl.ref) {
                        group.addChild(dl);
                    }
                }
            }
        });

        for (let group of groups) {
            const start = window.origin_convert_reverse(getPointForRef(group.p1));
            const end = window.origin_convert_reverse(getPointForRef(group.p2));
            const line = new window.paper.Path.Line({
                from: [start.x, start.y],
                to: [end.x, end.y],
                strokeColor: "#4444EE",
                strokeWidth: 50,
            });

            let start_range = getPointForRef(group.left_offset_max);
            start_range = window.origin_convert_reverse(start_range);
            let end_range = getPointForRef(group.right_offset_max);
            end_range = window.origin_convert_reverse(end_range);
            const range_line = new window.paper.Path.Line({
                from: [start_range.x, start_range.y],
                to: [end_range.x, end_range.y],
                strokeColor: "red",
                strokeWidth: 25,
            });

            const beam_start_pnt = new window.paper.Point(start.x, start.y);
            const beam_end_pnt = new window.paper.Point(end.x, end.y);

            const start_range_pnt = new window.paper.Point(start_range.x, start_range.y);
            const end_range_pnt = new window.paper.Point(end_range.x, end_range.y);

            const offset_dist = distancePointToLine(group.position, start_range_pnt, end_range_pnt);

            group.initial_position = group.position;
            window.last_pop_item = group;
            window.last_pop_item.beam_start_pnt = beam_start_pnt;
            window.last_pop_item.beam_end_pnt = beam_end_pnt;
            window.last_pop_item.start_range_pnt = start_range_pnt;
            window.last_pop_item.end_range_pnt = end_range_pnt;
            window.last_pop_item.offset_dist = offset_dist;
        }
    }

    function drawDimensionLine(start, end, second) {
        // Calculate dimension span: from projected to end_pnt
        const dimStart = start;
        const dimEnd = end;
        const dimVec = dimEnd.subtract(dimStart);
        const dimLength = dimVec.length;

        // Find the midpoint for the label
        const midPoint = dimStart.add(dimVec.multiply(0.5));

        // Find the normal vector for terminators
        // Compute dim normal (from dimVec) but force it to the preferred side
        let normal = new window.paper.Point(-dimVec.y, dimVec.x);
        if (normal.length < 1e-6) {
            normal = new window.paper.Point(0, 1);
        } else {
            normal = normal.normalize();
        }

        // Preferred normal from the range/reference line so text always goes to the same "outside" side
        const rangeVec = dimEnd.subtract(dimStart);
        let preferredNormal = new window.paper.Point(-rangeVec.y, rangeVec.x);
        if (preferredNormal.length < 1e-6) {
            preferredNormal = new window.paper.Point(0, 1);
        } else {
            preferredNormal = preferredNormal.normalize();
        }

        // If normals point opposite, flip the dim normal so terminators/text stay on preferred side
        if (normal.dot(preferredNormal) < 0) {
            normal = normal.multiply(-1);
        }

        const terminatorLength = 150; // Length of the terminator lines
        const fontSize = 128;

        // Points for terminators (use 'normal' so they are perpendicular to dimVec)
        const t1a = dimStart.add(normal.multiply(terminatorLength / 2));
        const t1b = dimStart.subtract(normal.multiply(terminatorLength / 2));
        const t2a = dimEnd.add(normal.multiply(terminatorLength / 2));
        const t2b = dimEnd.subtract(normal.multiply(terminatorLength / 2));

        let tempDimensionText = window.tempDimensionText;
        let tempTerminator1 = window.tempTerminator1;
        let tempTerminator2 = window.tempTerminator2;
        let tempDimensionLine = window.tempDimensionLine;

        if (second) {
            tempDimensionText = window.temp2DimensionText;
            tempTerminator1 = window.temp2Terminator1;
            tempTerminator2 = window.temp2Terminator2;
            tempDimensionLine = window.temp2DimensionLine;
        }

        // Remove previous temp items
        if (tempDimensionText) tempDimensionText.remove();
        if (tempTerminator1) tempTerminator1.remove();
        if (tempTerminator2) tempTerminator2.remove();
        if (tempDimensionLine) tempDimensionLine.remove();

        // Draw dimension line (optional, for clarity)
        tempDimensionLine = new window.paper.Path.Line({
            from: dimStart,
            to: dimEnd,
            strokeColor: "#c07026ff",
            strokeWidth: 10,
            dashArray: [6, 4],
        });

        // Draw terminators
        tempTerminator1 = new window.paper.Path.Line({
            from: t1a,
            to: t1b,
            strokeColor: "#c07026ff",
            strokeWidth: 20,
        });
        tempTerminator2 = new window.paper.Path.Line({
            from: t2a,
            to: t2b,
            strokeColor: "#c07026ff",
            strokeWidth: 20,
        });

        // Draw dimension text:
        // place at midpoint, offset outward using preferredNormal and add a baseline fudge so the
        // PointText baseline doesn't overlap the dim line.
        const textOffset = terminatorLength / 2 + fontSize * 0.5; // tweak 1 if needed
        const textPoint = midPoint.add(preferredNormal.multiply(-textOffset));

        tempDimensionText = new window.paper.PointText({
            point: textPoint,
            content: `${dimLength.toFixed(0)} mm`,
            fillColor: "#c07026ff",
            fontSize: fontSize,
            justification: "center",
        });

        if (second) {
            window.temp2DimensionText = tempDimensionText;
            window.temp2Terminator1 = tempTerminator1;
            window.temp2Terminator2 = tempTerminator2;
            window.temp2DimensionLine = tempDimensionLine;
        } else {
            window.tempDimensionText = tempDimensionText;
            window.tempTerminator1 = tempTerminator1;
            window.tempTerminator2 = tempTerminator2;
            window.tempDimensionLine = tempDimensionLine;
        }
    }

    function UpdateSplice(distance) {
        const existing_splice_adjustment = AreaSpecifications[areaIndex]?.SpliceAdjustments;
        let new_splice_adjustment = { ...existing_splice_adjustment };
        new_splice_adjustment[pop_item.ref] = distance;
        dispatch(updateAreaSpecification(pop_item.areaIndex, "SpliceAdjustments", null, new_splice_adjustment));
    }

    React.useEffect(() => {
        if (!loaded && props.open) {
            moveSplice();
            setLoaded(true);
        }
    }, [props?.open]);

    const moveSplice = () => {
        window.move_splice_waiting_for_points = true;
        setLastSVGLoaded(window.last_svg_load_attempt);
        ClearScratch();

        if (window.svg) {
            window.last_pop_item = props.pop_item;
            FormatSVGForMovingSplice(props.pop_item);
        }

        dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, true));
        dispatch(APP.update2DDesigner(APP.SELECTED_POINT, false));
        dispatch(APP.update2DDesigner(APP.SELECT_POINT, "Custom"));

        window.tempDimensionText = null;
        window.tempTerminator1 = null;
        window.tempTerminator2 = null;
        window.tempDimensionLine = null;

        window.temp2DimensionText = null;
        window.temp2Terminator1 = null;
        window.temp2Terminator2 = null;
        window.temp2DimensionLine = null;

        window.prevTool = window.paper.tool;

        window.tempTool = new window.paper.Tool();

        let downPointScreen = null;
        window.tempTool.onMouseDown = function (event) {
            downPointScreen = event.point;
            window.dragging = false;
        };
        window.tempTool.onMouseMove = function (event) {
            if (downPointScreen && event.point) {
                var distance_screen_dragged = downPointScreen.getDistance(event.point);
                if (distance_screen_dragged > 7) {
                    window.dragging = true;
                }
            } else {
                window.dragging = false;
            }
            let group = window.last_pop_item;

            const beam_start_pnt = window.last_pop_item.beam_start_pnt;
            const beam_end_pnt = window.last_pop_item.beam_end_pnt;
            const start_range_pnt = window.last_pop_item.start_range_pnt;
            const end_range_pnt = window.last_pop_item.end_range_pnt;
            const offset_dist = window.last_pop_item.offset_dist;
            const dim_offset = 150;

            const point_on_line = projectPointToLine(event.point, start_range_pnt, end_range_pnt, true);
            const projected = offsetPointOnNormal(point_on_line, start_range_pnt, end_range_pnt, offset_dist);
            group.position = projected;

            var projected_dim_start = offsetPointOnNormal(point_on_line, start_range_pnt, end_range_pnt, dim_offset);
            var projected_dim_end = offsetPointOnNormal(beam_start_pnt, start_range_pnt, end_range_pnt, dim_offset);
            drawDimensionLine(projected_dim_start, projected_dim_end);

            projected_dim_end = projected_dim_start;
            projected_dim_start = offsetPointOnNormal(beam_end_pnt, start_range_pnt, end_range_pnt, dim_offset);
            drawDimensionLine(projected_dim_start, projected_dim_end, true);
        };
        window.tempTool.onMouseUp = function (event) {
            if (window.dragging) {
                window.dragging = false;
                downPointScreen = null;
                return;
            }
            let group = window.last_pop_item;
            if (event.event.button == 0) {
                // Left button
                window.tempTool.off("mousemove");
                window.tempTool.onMouseMove = null;

                const beam_start_pnt = window.last_pop_item.beam_start_pnt;
                const beam_end_pnt = window.last_pop_item.beam_end_pnt;
                const start_range_pnt = window.last_pop_item.start_range_pnt;
                const end_range_pnt = window.last_pop_item.end_range_pnt;
                let point_on_line = projectPointToLine(event.point, start_range_pnt, end_range_pnt, true);
                point_on_line = new window.paper.Point(point_on_line.x, point_on_line.y);
                UpdateSplice(distanceBetween(point_on_line, beam_start_pnt));
                onClose();
            } else if (event.event.button == 2) {
                // Right button - cancel
                group.position = group.initial_position;
                onClose();
            }
        };
        window.tempTool.activate();
    };

    const onClose = () => {
        ClearScratch();
        setLoaded(false);

        if (window.tempDimensionText) window.tempDimensionText.remove();
        if (window.tempTerminator1) window.tempTerminator1.remove();
        if (window.tempTerminator2) window.tempTerminator2.remove();
        if (window.tempDimensionLine) window.tempDimensionLine.remove();
        if (window.temp2DimensionText) window.temp2DimensionText.remove();
        if (window.temp2Terminator1) window.temp2Terminator1.remove();
        if (window.temp2Terminator2) window.temp2Terminator2.remove();
        if (window.temp2DimensionLine) window.temp2DimensionLine.remove();

        window.tempTool.remove();
        window.tempTool = null;
        if (window.prevTool) {
            window.prevTool.activate();
        }
        window.move_splice_waiting_for_points = false;
        dispatch(APP.update2DDesigner(APP.SELECTED_POINT, false));
        dispatch(APP.update2DDesigner(APP.SELECT_POINT, false));
        dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, false));

        dispatch(updateLayout2D());
        if (props.onClose) {
            props.onClose();
            return;
        }
    };

    return (
        <div
            style={{
                maxWidth: "450px",
                textAlign: "left",
                top: "100px",
                padding: "10px",
                background: "#d7751bab",
                position: "absolute",
                right: "12px",
                zIndex: "5",
                color: "white",
            }}
        >
            <>
                Move splice and click to confirm location. <br />
                *Right click or press 'ESC' to cancel.
            </>
        </div>
    );
}
